import {
  Levels,
  SupportedLanguages,
  getLanguageInfo,
} from "@lingoshade/domain";
import { MenuItem, Stack, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface MaterialFilterValues {
  language: string;
  level: string;
}
interface Props extends MaterialFilterValues {
  onChange: (filters: MaterialFilterValues) => void;
  disabled?: boolean;
}
export default function MaterialFilters({
  language,
  level,
  onChange,
  disabled,
}: Props): React.ReactElement {
  const { t } = useTranslation("texts");
  const { t: common } = useTranslation("common");
  return (
    <Stack direction="row" spacing={1} sx={{ minWidth: 0 }}>
      <TextField
        select
        size="small"
        label={t("generateDialog.language")}
        value={language}
        slotProps={{
          select: { displayEmpty: true },
          inputLabel: { shrink: true },
        }}
        disabled={disabled}
        onChange={(event): void =>
          onChange({ language: event.target.value, level })
        }
        sx={{ flex: 1, minWidth: 140 }}
      >
        <MenuItem value="">{t("materials.allLanguages")}</MenuItem>
        {SupportedLanguages.map(
          (code): React.ReactElement => (
            <MenuItem key={code} value={code}>
              {getLanguageInfo(code).nativeName}
            </MenuItem>
          ),
        )}
      </TextField>
      <TextField
        select
        size="small"
        label={t("generateDialog.level")}
        value={level}
        slotProps={{
          select: { displayEmpty: true },
          inputLabel: { shrink: true },
        }}
        disabled={disabled}
        onChange={(event): void =>
          onChange({ language, level: event.target.value })
        }
        sx={{ flex: 1, minWidth: 140 }}
      >
        <MenuItem value="">{t("materials.allLevels")}</MenuItem>
        {Levels.map(
          (code): React.ReactElement => (
            <MenuItem key={code} value={code}>
              {common(`levels.${code}`)}
            </MenuItem>
          ),
        )}
      </TextField>
    </Stack>
  );
}
